module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei1.svg";